/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSupplementalResponseRequest
 */
export interface CreateSupplementalResponseRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateSupplementalResponseRequest
     */
    interrogatoriesToSupplement?: Array<number> | null;
}

export function CreateSupplementalResponseRequestFromJSON(json: any): CreateSupplementalResponseRequest {
    return CreateSupplementalResponseRequestFromJSONTyped(json, false);
}

export function CreateSupplementalResponseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupplementalResponseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interrogatoriesToSupplement': !exists(json, 'interrogatoriesToSupplement') ? undefined : json['interrogatoriesToSupplement'],
    };
}

export function CreateSupplementalResponseRequestToJSON(value?: CreateSupplementalResponseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interrogatoriesToSupplement': value.interrogatoriesToSupplement,
    };
}


